module.exports = __webpack_public_path__ + "static/media/Политика за съхранение и унищоване на личните данни.65cde783.pdf";